export default __webpack_public_path__ + "static/media/1492509294_videos_ios7_ios_7.6215251e.png";